export const wordsList: string[] = [
  "أواخر",
  "أوائل",
  "بلدات",
  "ترجمة",
  "حقيقة",
  "حقائق",
  "خلافة",
  "علماء",
  "أوصاف",
  "أهالي",
  "أحوال",
  "رحلات",
  "ترحال",
  "رحالة",
  "تسجيل",
  "أسواق",
  "طبعات",
  "عظماء",
  "تقديم",
  "قافلة",
  "قوافل",
  "كاملة",
  "مناظر",
  "تحضير",
  "مشروب",
  "مطبوخ",
  "مطلوب",
  "عادات",
  "إفطار",
  "وجبات",
  "أراضي",
  "أساسي",
  "حفلات",
  "أحياء",
  "خفيفة",
  "تزيين",
  "ساحات",
  "صناعة",
  "طبلات",
  "طرقات",
  "طريقة",
  "أعباء",
  "أعياد",
  "فقراء",
  "أموال",
  "أنواع",
  "متنوع",
  "تأسيس",
  "مؤسسة",
  "تسمية",
  "بداية",
  "إخراج",
  "سلطات",
  "شعبية",
  "صحافة",
  "طباعة",
  "مطبعة",
  "مطابع",
  "طبيعي",
  "طبيعة",
  "عصرية",
  "إنشاء",
  "حكومة",
  "دولية",
  "رسمية",
  "تركيز",
  "زراعة",
  "مشروع",
  "تطوير",
  "مظاهر",
  "تعبير",
  "عسكري",
  "عساكر",
  "أنظمة",
  "أهداف",
  "مجتمع",
  "مراجع",
  "مراكز",
  "سياسة",
  "شهادة",
  "ندوات",
  "نظرية",
  "تناول",
  "إيمان",
  "أبحاث",
  "بعثات",
  "تلميذ",
  "ثورات",
  "حديثة",
  "حركات",
  "خطيرة",
  "دعوات",
  "أرواح",
  "روحية",
  "زيادة",
  "عبقري",
  "مقاعد",
  "قيادة",
  "كفاية",
  "توزيع",
  "إيفاد"
];

export const day = (): number => {
  const TODAY = new Date();
  const start = new Date(2024, 1, 11);
  const diff = Number(TODAY) - Number(start);
  return Math.floor(diff / (1000 * 60 * 60 * 24));
};

export const getWordOfTheDay = (): string => {
  let theDay = day();
  while (theDay > wordsList.length) {
    theDay--;
  }
  const rndInt = Math.floor(Math.random() * 60) + 1
  return wordsList[rndInt];
};
